import { StepSlug } from '@fiverr-private/store_builder_types';

export const ROOT_ROUTE = 'root';
export const BASE_PATH = '/ai-store-builder';
export const SHOPIFY = '/shopify';

export type Route = `${typeof SHOPIFY}/${StepSlug}`;

export const ROUTES: Record<string, Route> = {
    CHOOSE_NICHE: `/shopify/choose-niche`,
    CHOOSE_BANNERS: `/shopify/choose-banners`,
    CHOOSE_SELLING_PLAN: `/shopify/choose-selling-plan`,
    SIGN_UP: `/shopify/sign-up`,
    LINK_YOUR_STORE: `/shopify/link-your-store`,
    INSTALL_APP: `/shopify/install-app`,
    SUBSCRIBE: `/shopify/subscribe`,
    CREATE_STORE: `/shopify/create-store`,
    ADDITIONAL_SERVICES: `/shopify/additional-services`,
    SUBSCRIBE_AUTODS: `/shopify/subscribe-autods`,
    PUBLISH: `/shopify/publish`,
} as const;
